export function readImageFromFile(file) {
	const reader = new FileReader();

	return new Promise((resolve, reject) => {
		reader.onload = event => {
			const image = new Image();

			image.onload = () => resolve(image);
			image.src = reader.result;
		}

		reader.readAsDataURL(file);
	});
}




// WEBPACK FOOTER //
// ./src/util/image-utils.js